module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.api))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ae))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ae) + " kW")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ie))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ie) + " kW")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_power))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_reactive_energy))])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "energy-cvc10-act-react"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26d1361e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/device_partials/EnergyAnalyzer.vue
// module id = 537
// module chunks = 1